import { Link } from "react-router-dom";
import { DEPARTMENTS } from "@neus/shared";
import { useFacets } from "../api/hooks";
import { CONTENT } from "../content";
import { usePageTitle } from "../usePageTitle";
import styles from "./pages.module.css";

export function DepartmentTiles({ includeAll = false }: { includeAll?: boolean }) {
  // The home page shows the brand's menu departments; the departments page shows them all.
  const list = DEPARTMENTS.filter((d) => includeAll || d.inMenu);
  return (
    <div className={styles.tiles}>
      {list.map((d) => (
        <Link key={d.slug} to={`/${d.slug}`} className={styles.tile} data-dept={d.slug}>
          <h3>{d.name}</h3>
          <p>{d.blurb}</p>
          <span className={styles.tileCta}>Shop now →</span>
        </Link>
      ))}
    </div>
  );
}

export function DepartmentsPage() {
  usePageTitle(CONTENT.site.pageMeta["/departments"]?.title);
  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>Departments</h1>
        </div>
      </div>
      <div className="container section">
        <DepartmentTiles includeAll />
      </div>
    </>
  );
}

export function BrandsPage() {
  const { data, isLoading } = useFacets();
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> / <Link to="/products">Products</Link> / Brands
          </div>
          <h1>Brands You Know. People You Trust.</h1>
        </div>
      </div>
      <div className="container section">
        {isLoading ? (
          <p>Loading brands…</p>
        ) : (
          <div className={styles.brandGrid}>
            {data?.brands.map((b) => (
              <Link key={b.slug} to={`/brands/${b.slug}`} className={styles.brandTile}>
                <strong>{b.name}</strong>
                <span className="muted">
                  {b.count} product{b.count === 1 ? "" : "s"}
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
